import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import './AdminPanel.css';

// --- CORE COMPONENTS ---
import Navbar from '../Navbar/Navbar';
import Sidebar from '../Sidebar/Sidebar';

// --- PAGE COMPONENTS ---
import AdminProfile from '../AdminLogin/AdminProfile';
import UserDetails from '../UserDetails/UserDetails';
import Reports from '../Reports/Reports';
import Payments from '../Payments/Payments';
import PaymentPackages from '../PaymentPackages/PaymentPackages';
import Councellings from '../Councellings/Councellings';
import Sessions from '../Councellings/Sessions';
import BookSession from '../Councellings/BookSession';
import EmailService from '../Services/EmailService';
import List from '../EmailTemplate/List';
import EmailConfiguration from '../EmailTemplate/EmailConfiguration';
import Settings from './Settings';
import JobScheduler from './JobScheduler';
import Prompt from '../Prompt/Prompt';
import Coupon from '../Coupon/Coupon';
import Forum from '../Forum/Forum';
import ForumAdmin from '../ForumAdmin/ForumAdmin';
import RefundCoupon from '../Coupon/RefundCoupon';
import Ai from '../AI';
import LoadingFacts from '../LoadingFacts/LoadingFacts';

// --- FIX: Corrected the import path ---
import CouponAnalytics from '../Reports/CouponAnalytics'; 

// IMPORT THE OTHER COMPONENTS
import EmailMarketing from '../EmailMarketing/EmailMarketing';
import EmailTemplate from '../EmailTemplate/EmailTemplate';

const AdminPanel = ({ onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [admin, setAdmin] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const adminData = localStorage.getItem('adminUser');
    if (adminData) {
      setAdmin(JSON.parse(adminData));
    }
  }, []);

  const handleNavigation = (path) => {
    if (path) {
      navigate(`/admin/${path}`);
    }
  };

  const getTabTitle = () => {
    const path = location.pathname.split('/').pop();
    switch (path) {
      case 'userdetails': return 'User Details';
      case 'reports': return 'Reports';
      case 'coupon-analytics': return 'Coupon Usage Analytics';
      case 'counsellings': return 'Counsellings';
      case 'loading-facts': return 'Loading Facts';
      case 'forum': return 'Discussion Forum';
      case 'forum-admin': return 'Forum Management';
      case 'email-marketing': return 'Email Marketing';
      case 'sessions': return 'Sessions';
      case 'book-session': return 'Book Session';
      case 'packages': return 'Payment Packages';
      case 'payments': return 'Payments';
      case 'coupon': return 'Manage Payment Coupons';
      case 'refund-coupons': return 'Manage Refund Coupons';
      case 'email-service': return 'EmailService';
      case 'list': return 'Email Lists';
      case 'emailtemplate': return 'Manage Email Templates';
      case 'emailconfiguration': return 'Email Configuration';
      case 'settings': return 'System Settings';
      case 'profile': return 'Admin Profile';
      case 'job-scheduler': return 'Job Scheduler';
      case 'prompt': return 'Manage Prompts';
      case 'ai': return 'AI';
      default: return 'Dashboard';
    }
  };

  return (
    <div className="admin-panel">
      <Sidebar isOpen={sidebarOpen} />

      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <Navbar
          title={getTabTitle()}
          onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
          admin={admin}
          onLogout={onLogout}
        />

        <div className="content-body">
          <Routes>
            <Route index element={<UserDetails />} />
            
            {/* Main Routes */}
            <Route path="userdetails" element={<UserDetails />} />
            <Route path="user-details/:userId" element={<UserDetails />} />
            <Route path="reports" element={<Reports />} />
            <Route path="coupon-analytics" element={<CouponAnalytics />} />
            <Route path="packages" element={<PaymentPackages />} />
            <Route path="payments" element={<Payments />} />
            <Route path="coupon" element={<Coupon />} />
            <Route path="refund-coupons" element={<RefundCoupon />} />
            <Route path="forum" element={<Forum />} />
            <Route path="forum-admin" element={<ForumAdmin />} />
            <Route
              path="settings"
              element={<Settings onNavigate={handleNavigation} />}
            />

            <Route path="job-scheduler" element={<JobScheduler />} />
            <Route path="profile" element={<AdminProfile />} />

            {/* Counselling Routes */}
            <Route path="counsellings" element={<Councellings />} />
            <Route path="loading-facts" element={<LoadingFacts />} />
            <Route path="sessions" element={<Sessions />} />
            <Route path="book-session" element={<BookSession />} />

            {/* Email Routes */}
            <Route path="email-marketing" element={<EmailMarketing />} />
            <Route path="emailtemplate" element={<EmailTemplate />} />
            <Route path="email-service" element={<EmailService />} />
            <Route path="list" element={<List />} />
            <Route path="emailconfiguration" element={<EmailConfiguration />} />
            
            <Route path="prompt" element={<Prompt />} />
            <Route path="ai" element={<Ai />} />
            
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;